import { render, staticRenderFns } from "./MissionNewbieTable.vue?vue&type=template&id=0ed83aca&scoped=true&"
import script from "./MissionNewbieTable.vue?vue&type=script&lang=js&"
export * from "./MissionNewbieTable.vue?vue&type=script&lang=js&"
import style0 from "./MissionNewbieTable.vue?vue&type=style&index=0&id=0ed83aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed83aca",
  null
  
)

export default component.exports